export const POST = 'POST'
export const GET = 'GET'
export const PUT = 'PUT'